const state = {
  payment_method: [],
  payment_method_id: [],
  payment_method_popup: [],
  product_location_id: [],
  product_location: [],
  product_location_popup: [],
  all_type: [],
  group_by: [],
};

export default state;
